import { useState, useEffect, useRef } from "react";
// import { useInView } from "react-intersection-observer";
import ReactGA from "react-ga4";
import Page from "../page/page";

import "./animationPage.scss";
import classnames from "classnames";
import { useMediaQuery } from "@react-hook/media-query";
import classNames from "classnames";

const AnimationPage = () => {
  const isPortrait = useMediaQuery("only screen and (orientation: portrait)");

  const targetRef = useRef(null);

  const nav = () => {
    //@ts-ignore
    targetRef?.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "Influence Page",
    });
  }, []);

  return (
    <Page
      style={{
        paddingBottom: "0px",
      }}
      className="teamBuildingPage"
    >
      <div className={classnames("welcomeBigtext", "sectionZero")}>
        {isPortrait ? (
          <>
            <span className="welcomeBigText2">Le ring de boxe</span>
            {/* <span className="welcomeBigText1">la Baba - </span> */}
            <div className="welcomeBigText3">2.0</div>
            <div className="welcomeHint1">Animation clef en main</div>
            <div className="welcomeHint2">Partout en France </div>
          </>
        ) : (
          <>
            <span className="welcomeBigText2">Le ring de boxe</span>{" "}
            {/* <span className="welcomeBigText1">la Baba -</span> */}
            <div className="welcomeBigText3">2.0</div>
            <div className="welcomeHint1">Animation clef en main</div>
            <div className="welcomeHint2">Partout en France </div>
          </>
        )}
      </div>
      <div className="firstPagePlaceholder" />
      <div className="sectionTwo">
        <div className="presenter">
          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText"> Une activité</div>
            <div className="welcomeBigText5 presenterText"> de 9 à 99 ans </div>
            <img className="explainImage" src="./teambuildings/fun.png" />
          </div>

          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText">
              {" "}
              Une installation rapide
            </div>
            <div className="welcomeBigText5 presenterText">et sécurisée</div>
            <img className="explainImage" src="./game/installation.png" />
          </div>

          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText">
              {" "}
              Un réseau d'influenceurs
            </div>
            <div className="welcomeBigText5 presenterText"> partenaires</div>
            <img className="explainImage" src="./game/partenaires.png" />
          </div>
        </div>
      </div>

      <div className="sectionOne">
        <div className="videoAndBannersContainer">
          <div className="videoTitle">
            🎯✨Réinventons votre marketing évènementiel ensemble.
            <br />
            <br />
            🛡️Nous proposons une animation clef en main, déployable dans vos
            espaces, entièrement sécurisée.
            <br />
            <br />
            🤼‍♂️Dans nos rings virtuels, petits et grands vont s'affronter🥊en
            famille ou entre amis, sans se toucher !
            <br />
            <br /> 📈Vous souhaitez booster votre fréquentation grâce à nos
            influenceurs ? Nous les invitons dans votre espace ... sans qu'ils
            bougent de chez eux ! 🏠
            {/* <div className="arrowDown"></div>
            <div className="arrowDown2"></div>{" "} */}
          </div>
          {/* <div className="videoWrapper">
            {isPortrait ? (
              <iframe
                width="100%"
                height="600"
                src="https://www.youtube.com/embed/ESmcMxs9xCw"
                title="Shotam : Trailer"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
              ></iframe>
            ) : (
              <div className="trailerContainer">
                <iframe
                  width="500"
                  height="282"
                  // src="https://www.youtube.com/embed/RTw6ekGqoyQ"
                  src="https://www.youtube.com/embed/CByvdQuk9W4"
                  title="Shotam : Trailer"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
                ></iframe>
              </div>
            )}
          </div> */}
        </div>
      </div>

      <div className={classnames("sectionTwo", "sectionThree")} ref={targetRef}>
        <div style={{ width: "100% ", textAlign: "center", marginTop: 50 }}>
          Contactez-nous pour en savoir plus sur notre offre d'animation, et le
          détail complet de nos grilles tarifaires.
        </div>
        <a
          className={classNames("mailLink", "showBookingButton")}
          href="mailto:contact@shotam.com"
        >
          contact@shotam.app
        </a>
        {/* <div className="presenter">
          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText"> Collaborez </div>
            <div className="welcomeBigText5 presenterText"> en équipe </div>
            <div className="imageAndTextContainer">
              <img
                className="explainImage"
                src="./teambuildings/teamplay.png"
              />
              <div className="imageExplanation">
                Élaborez ensemble votre stratégie d'attaque/défense en fonction
                de vos pouvoirs respectifs !
              </div>
            </div>
          </div>

          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText">Brûlez</div>
            <div className="welcomeBigText5 presenterText"> des calories</div>
            <div className="imageAndTextContainer">
              <img className="explainImage" src="./teambuildings/motion.png" />
              <span className="imageExplanation">
                Das l'arène Shotam, tous vos mouvements deviennent un
                superpouvoir !
              </span>
            </div>
          </div>

          <div className="presenterSection">
            <div className="welcomeBigText4 presenterText">Amusez-vous </div>
            <div className="welcomeBigText5 presenterText"> comme jamais !</div>
            <div className="imageAndTextContainer">
              <img className="explainImage" src="./teambuildings/fun.png" />
              <span className="imageExplanation">
                Qui n'a jamais rêvé de devenir un superhéros ?
              </span>
            </div>
          </div>
        </div> */}
      </div>
    </Page>
  );
};

export default AnimationPage;
